import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Input } from 'reactstrap';
import queryString from 'query-string';
import Axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Store } from '../../../../store';
import {
    changeOpcoesResultado,
    changeOpcoesNovasAquisicoes,
} from '../../../../store/ducks/pesquisa';
import { ConsultaAPI, ResourcesAPI, ParametrosAPI } from '../../../../shared/http-requests';
import { ConsultaHelper, APIHelper } from '../../../../shared/helpers';
import ConteudoPesquisaAutoridade from './contents/ConteudoPesquisaAutoridade';
import ConteudoPesquisaGeralPorIndice from './contents/ConteudoPesquisaGeralPorIndice';
import ConteudoPesquisaAutomaticaNovasAquisicoes from './contents/ConteudoPesquisaAutomaticaNovasAquisicoes';
import ConteudoPesquisaCatalogoRedePergamum from './contents/ConteudoPesquisaCatalogoRedePergamum';
import ConteudoPesquisaAbnt from './contents/ConteudoPesquisaAbnt';
import ConteudoPesquisaTargetGedWeb from './contents/ConteudoPesquisaTargetGedWeb';
import ConteudoPesquisaOAI from './contents/ConteudoPesquisaOAI';
import ConteudoPesquisaGeral from './contents/ConteudoPesquisaGeral';
import SemConteudo from './contents/SemConteudo';
import { useAppContext } from '../../../../shared/contexts/AppContextProvider';
import { changeLogoById } from '../../../../store/ducks/pageConfig';
import { VERSAO_PESQUISA_PAGINADA } from '../../../../shared/const';
import { useSearchParams, usePesquisaPaginadaParams, usePrefiterParams } from '../../../../shared/hooks';
import { LAST_CACHE_DATE } from '../../consts';
import { useSearchContext } from '../../../../shared/contexts/SearchContextProvider';

const BaseTemplate = React.lazy(() => import('../template/BaseTemplate'));
const HomeHeader = React.lazy(() => import('../../components/Home/HomeHeader'));

function Home({
    location,
    match,
    history,
    consultaRx,
    ultimoLogRx,
    acervosFiltradosRx,
    guiasPesquisaRx,
    opcoesResultadoRx,
    cestaRx,
    opcoesNovasAquisicoes,
    filtrosSelecionados,
    logoById
}) {
    const { t } = useTranslation();
    // ? Selecionar todos os checkbox:
    const [selectAll, toggleSelectAll] = useState(false);
    // ? Consulta que irá aparecer na tela:
    const [itensConsulta, setItensConsulta] = useState(false);
    // ? Opções da combo de ordenação
    const [ordenacao, setOrdenacao] = useState(false);
    const { orderBy, perPage, clearSearch } = useSearchContext()
    const { setSelectedTab } = useAppContext();
    const { setPage, setPerPage } = usePesquisaPaginadaParams();
    const { clearSearchParams } = useSearchParams();
    const { getAll } = usePrefiterParams();

    useEffect(() => {
        if(logoById !== null) return;
        const cancelToken = Axios.CancelToken.source();
        const { id } = getAll();
        if (id) {
            ResourcesAPI.getLogoById(encodeURI(id), cancelToken.token).then(response => {
                if(response && response?.data){
                    Store.dispatch(changeLogoById(response.data))
                }
            }).catch((error) => {
                console.log('Error on get logo by id: ', error)
            })
            return () => {
                cancelToken.cancel();
            }
        }
    }, [logoById, getAll]);

    /**
     * Verify cache
     */
    useEffect(() => {
        if(match?.path?.trim() === '/') {
            (async () => {
                try{
                    const responseGetLastCacheDate = await ParametrosAPI.getLastCacheDate()
                    const { data } = responseGetLastCacheDate;
                    const { last_cache_date } = data;

                    if (last_cache_date) {
                        const inNavigatorLastCacheData = sessionStorage.getItem(LAST_CACHE_DATE)
                        if(!inNavigatorLastCacheData){
                            sessionStorage.setItem(LAST_CACHE_DATE, last_cache_date)
                        }else{
                            const parsedLastCacheDate = new Date(last_cache_date)
                            const parsedLastCacheInSession = new Date(inNavigatorLastCacheData)
                            if(parsedLastCacheInSession < parsedLastCacheDate){
                                sessionStorage.clear()
                                localStorage.clear();
                                sessionStorage.setItem(LAST_CACHE_DATE, last_cache_date)
                                console.log(`Cache limpo! Nova data: ${last_cache_date}`)
                                window.location.reload()
                            }
                        }
                    }
                }catch (e) {
                    console.log(`Houve um erro no tratamento do cache: ${e}`)
                }

            })();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const guiaSelecionada =
        match.params.guia ||
        (guiasPesquisaRx &&
            guiasPesquisaRx.length &&
            guiasPesquisaRx.find(guia => guia.ordem === 0)?.codigo);

    useEffect(() => {
        setSelectedTab(guiaSelecionada)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guiaSelecionada])

    /**
     *  Verifica se a guia da URL existe, se não existe, redireciona para a principal
     */
    useEffect(() => {
        if (guiasPesquisaRx && guiasPesquisaRx.length && match.params.guia) {
            if (
                !guiasPesquisaRx.find(
                    guia => guia?.codigo === match.params.guia,
                )
            ) {
                history.push('/');
            }
        }
    }, [match, history, guiasPesquisaRx]);

    useEffect(() => {
        if (consultaRx && consultaRx !== 'error') {
            if (consultaRx.searchVersion === VERSAO_PESQUISA_PAGINADA) {
                setItensConsulta(consultaRx.data);
                return;
            };
            let consultaFiltrada = [];

            if (acervosFiltradosRx.length > 0) {
                if (['rede_pergamum_oai', 'rede_oai_local'].includes(
                    consultaRx.base,
                )) {
                    consultaFiltrada = consultaRx.data.filter(acervo =>
                        acervosFiltradosRx.some(a => a === acervo.id),
                    );
                } else {
                    consultaFiltrada = consultaRx.data.filter(acervo =>
                        acervosFiltradosRx.some(a => a === acervo.cod_acervo),
                    );
                }
            } else {
                if (filtrosSelecionados.length) {
                    setItensConsulta([]);
                    return;
                }
                consultaFiltrada = consultaRx.data;
            }

            /**
             * Implementação da ordenação
             */

            const fieldOrder = opcoesResultadoRx?.ordenacaoCombo
                ? opcoesResultadoRx?.ordenacaoCombo
                : 'obra';

            consultaFiltrada = consultaFiltrada?.sort((a, b) => {
                let argAToOrder = a[fieldOrder];
                let argBToOrder = b[fieldOrder];

                if (['cod_tipo_obra', 'cod_acervo'].includes(fieldOrder)) {
                    argAToOrder = parseInt(argAToOrder, 10);
                    argBToOrder = parseInt(argBToOrder, 10);
                }

                if (opcoesResultadoRx.ordenacao === 'D') {
                    return argAToOrder < argBToOrder ? 1 : -1;
                }

                return argAToOrder > argBToOrder ? 1 : -1;
            });
            // ordena de A a Z o retorno de autoridades
            if (consultaRx.pesquisa === 'autoridades' ){
                consultaFiltrada.sort((a, b) => {
                    if (a.desc_titulo < b.desc_titulo) return -1;
                    if (a.desc_titulo > b.desc_titulo) return 1;
                    return 0;
                })
            };

            if (consultaRx.pesquisa === 'autoridades' ){
                consultaFiltrada.sort((a, b) => {
                    if (a.desc_titulo < b.desc_titulo) return -1;
                    if (a.desc_titulo > b.desc_titulo) return 1;
                    return 0;
                })
            };

            setItensConsulta(
                consultaFiltrada?.filter(
                    (registro, index) =>
                        index >=
                            opcoesResultadoRx.quantPag *
                                (opcoesResultadoRx.paginaAtiva - 1) &&
                        index <
                            opcoesResultadoRx.quantPag *
                                opcoesResultadoRx.paginaAtiva &&
                        registro,
                ),
            );
        } else setItensConsulta(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        consultaRx,
        acervosFiltradosRx,
        opcoesResultadoRx.quantPag,
        opcoesResultadoRx.ordenacao,
        opcoesResultadoRx.ordenacaoCombo,
    ]);

    useEffect(() => {
        if (filtrosSelecionados.length === 0 && itensConsulta.length === 0) {
            setItensConsulta(consultaRx.data);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filtrosSelecionados]);

    useEffect(() => {
        const cancelToken = Axios.CancelToken.source();

        if(!consultaRx?.id) return;

        if (!ordenacao && consultaRx) {
            if (validaBuscarOrdenacao()) {
                ConsultaAPI.ordenacao(cancelToken.token)
                    .then(response => {
                        if (response.data.length) setOrdenacao(response.data);
                    })
                    .catch(error => {
                        if (!Axios.isCancel(error)) APIHelper.tratarErro(error);
                    });
            }
        } else if (ordenacao && consultaRx) {
            if (!opcoesResultadoRx.ordenacaoCombo)
                mudarOrdenacaoComboRedux(
                    orderBy !== undefined ? orderBy :
                        ordenacao.find(ord => ord.default)?.codigo,
                );
            if (consultaRx?.id !== ultimoLogRx?.id) setOrdenacao(false);
        }
        // ? cleanup
        return () => cancelToken.cancel();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ordenacao, consultaRx.id]);

    const mudarOrdenacaoComboRedux = codigo => {
        Store.dispatch(
            changeOpcoesResultado({
                ...opcoesResultadoRx,
                ordenacaoCombo: codigo,
            }),
        );
    };


    /**
     * Cada vez que o usuário selecionar um item, trocar a página, ou a ordenação
     * valida se todos os itens da tela estão na cesta para marcar o selectAll
     */
    useEffect(() => {
        if (itensConsulta) {
            const todosCesta = itensConsulta.every(item =>
                cestaRx.some(i => i.cod_acervo === item.cod_acervo),
            );
            if (todosCesta !== selectAll) toggleSelectAll(todosCesta);
        }
    }, [cestaRx, opcoesResultadoRx.paginaAtiva, itensConsulta, selectAll]);

    const validaBuscarOrdenacao = () => {
        const urlParams = queryString.parse(location.search);
        if (guiaSelecionada === 'autoridades' && !urlParams.aut_id)
            return false;

        if(consultaRx.base === "rede_pergamum_oai")
            return false;

        if (
            guiaSelecionada === 'pesquisa_geral' &&
            ((urlParams.for &&
                urlParams.for.endsWith('_INDICE') &&
                urlParams.for !== 'TITULO_INDICE' &&
                !urlParams.index) ||
                consultaRx.base !== 'local')
        )
            return false;
        return true;
    };

    const limparConsulta = () => {
        if (consultaRx.searchVersion === VERSAO_PESQUISA_PAGINADA)
            clearSearchParams();
        ConsultaHelper.limparConsulta(() => setItensConsulta(false));

        clearSearch()
    };

    const mudarQuantidadePerPag = quant => {
        quant = parseInt(quant, 10);
        if (quant === opcoesResultadoRx.quantPag) return;

        if (consultaRx.searchVersion === VERSAO_PESQUISA_PAGINADA) {
            setPerPage(quant);
        }

        Store.dispatch(
            changeOpcoesResultado({
                ...opcoesResultadoRx,
                quantPag: quant,
                paginaAtiva: 1,
            }),
        );
    };

    const mudarPaginaResultado = pagina => {
        if (pagina === opcoesResultadoRx.paginaAtiva)
            return;

        if (consultaRx.searchVersion === VERSAO_PESQUISA_PAGINADA) {
            setPage(pagina);
            return;
        }
        let consultaFiltrada = [];
        if (acervosFiltradosRx.length > 0) {
            if (consultaRx.base === 'rede_pergamum_oai') {
                consultaFiltrada = consultaRx.data.filter(acervo =>
                    acervosFiltradosRx.some(a => a === acervo.id),
                );
            } else {
                consultaFiltrada = consultaRx.data.filter(acervo =>
                    acervosFiltradosRx.some(a => a === acervo.cod_acervo),
                );
            }
        } else {
            consultaFiltrada = consultaRx.data;
        }
            setItensConsulta(
                consultaFiltrada?.filter(
                    (registro, index) =>
                        index >= opcoesResultadoRx.quantPag * (pagina - 1) &&
                        index < opcoesResultadoRx.quantPag * pagina &&
                        registro,
                ),
            );
            Store.dispatch(
                changeOpcoesResultado({
                    ...opcoesResultadoRx,
                    paginaAtiva: pagina,
                    quantPag: perPage !== undefined ?
                        parseInt(perPage, 10) :
                        opcoesResultadoRx.quantPag
                }),
            );
            document
                .querySelector('.consultaContent')
                .scrollIntoView({ behavior: 'smooth' });

    };


    /**
     * @author Renan Salustiano <renan.salustiano@ter.grupomarista.org.br>
     * Condições para a renderização da tela, movidas para melhor leiturado código
     * @returns {{CONDICAO_PESQUISA_OAI: (function(): boolean),
     * CONDICAO_PESQUISA_ABNT: (function(): boolean),
     * CONDICAO_PESQUISA_GERAL_POR_INDICE: (function()),
     * CONDICAO_PESQUISA_TARGET_GED_WEB: (function(): boolean),
     * CONDICAO_PESQUISA_AUTORIDADE: (function()),
     * CONDICAO_PESQUISA_CATALOGO_REDE_PERGAMUM: (function(): boolean),
     * CONDICAO_PESQUISA_GERAL: (function(): *),
     * CONDICAO_PESQUISA_AUTOMATICA_NOVAS_AQUISICOES: (function())}}
     */
    const conditions = () => {
        const { pesquisa, base } = consultaRx;
        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_AUTORIDADE = () =>
            !!(
                pesquisa === 'autoridades' &&
                itensConsulta.some(a => !!a.cod_autoridade)
            );
        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_GERAL_POR_INDICE = () =>
            !!(
                pesquisa === 'pesquisa_geral' &&
                itensConsulta.every(a => a.obra && a.obra.trim() === '')
            );

        // itensConsulta.some(
        //     a =>
        //         a?.areas_conhecimento?.length > 0 ||
        //         a?.cursos_disc?.length > 0,
        // )

        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_AUTOMATICA_NOVAS_AQUISICOES = () =>
            !!(
                pesquisa === 'novas_aquisicoes' &&
                itensConsulta &&
                acervosFiltradosRx.length === 0 &&
                opcoesNovasAquisicoes.exibicao === 'L'
            );
        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_CATALOGO_REDE_PERGAMUM = () =>
            base === 'rede_pergamum';
        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_ABNT = () => base === 'abnt';
        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_TARGET_GED_WEB = () => base === 'target_gedweb';
        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_OAI = () => (['rede_pergamum_oai', 'oai_local', 'rede_oai_local'].includes(base)) ;
        /**
         *
         * @returns {boolean}
         * @constructor
         */
        const CONDICAO_PESQUISA_GERAL = () =>
            !!(
                filtrosSelecionados.length > 0 ||
                itensConsulta.every(i => i.cod_empresa)
            );

        return {
            CONDICAO_PESQUISA_AUTORIDADE,
            CONDICAO_PESQUISA_GERAL_POR_INDICE,
            CONDICAO_PESQUISA_AUTOMATICA_NOVAS_AQUISICOES,
            CONDICAO_PESQUISA_CATALOGO_REDE_PERGAMUM,
            CONDICAO_PESQUISA_ABNT,
            CONDICAO_PESQUISA_TARGET_GED_WEB,
            CONDICAO_PESQUISA_OAI,
            CONDICAO_PESQUISA_GERAL,
        };
    };

    const getContent = () => {
        let usaHeader = true;
        let usaModoExibicao = false;
        let content = null;

        try {
            if (itensConsulta?.length === 0) {
                usaHeader = false;
                /**
                 * Sem conteúdo - Alertas
                 * @type {JSX.Element}
                 */
                if (filtrosSelecionados.length > 0) {
                    content = (
                        <ConteudoPesquisaGeral
                            toggleSelectAll={toggleSelectAll}
                            selectAll={selectAll}
                            itensConsulta={itensConsulta}
                        />
                    );
                } else {
                    content = <SemConteudo />;
                }
            } else {
                const {
                    CONDICAO_PESQUISA_AUTORIDADE,
                    CONDICAO_PESQUISA_GERAL_POR_INDICE,
                    CONDICAO_PESQUISA_AUTOMATICA_NOVAS_AQUISICOES,
                    CONDICAO_PESQUISA_CATALOGO_REDE_PERGAMUM,
                    CONDICAO_PESQUISA_ABNT,
                    CONDICAO_PESQUISA_TARGET_GED_WEB,
                    CONDICAO_PESQUISA_OAI,
                    CONDICAO_PESQUISA_GERAL,
                } = conditions();

                switch (true) {
                    case CONDICAO_PESQUISA_AUTORIDADE():
                        /**
                         * Conteúdo Pesquisa autoridade
                         * @type {JSX.Element}
                         */
                        content = (
                            <ConteudoPesquisaAutoridade
                                itensConsulta={itensConsulta}
                            />
                        );
                        break;
                    case CONDICAO_PESQUISA_GERAL_POR_INDICE():
                        /**
                         * Conteúdo Pesquisa Geral por indice
                         * @type {JSX.Element}
                         */
                        content = (
                            <ConteudoPesquisaGeralPorIndice
                                itensConsulta={itensConsulta}
                            />
                        );
                        break;
                    case CONDICAO_PESQUISA_AUTOMATICA_NOVAS_AQUISICOES():
                        /**
                         * Conteúdo Pesquisa automática novas aquisições
                         * @type {JSX.Element}
                         */
                        content = <ConteudoPesquisaAutomaticaNovasAquisicoes />;
                        break;
                    case CONDICAO_PESQUISA_CATALOGO_REDE_PERGAMUM():
                        /**
                         * Conteúdo Pesquisa Catalogo Rede Pergamum
                         * @type {JSX.Element}
                         */
                        content = (
                            <ConteudoPesquisaCatalogoRedePergamum
                                itensConsulta={itensConsulta}
                            />
                        );
                        break;
                    case CONDICAO_PESQUISA_ABNT():
                        /**
                         * Conteúdo Pesquisa ABNT
                         * @type {JSX.Element}
                         */
                        content = (
                            <ConteudoPesquisaAbnt
                                itensConsulta={itensConsulta}
                            />
                        );
                        break;
                    case CONDICAO_PESQUISA_TARGET_GED_WEB():
                        content = (
                            <ConteudoPesquisaTargetGedWeb
                                itensConsulta={itensConsulta}
                            />
                        );
                        break;
                    case CONDICAO_PESQUISA_OAI():
                        /**
                         * Conteúdo Pesquisa OAI
                         * @type {JSX.Element}
                         */
                        content = (
                            <ConteudoPesquisaOAI
                                itensConsulta={itensConsulta}
                            />
                        );
                        break;
                    case CONDICAO_PESQUISA_GERAL():
                        usaModoExibicao = true;
                        /**
                         * Conteúdo Pesquisa Geral
                         * @type {JSX.Element}
                         */
                        content = (
                            <ConteudoPesquisaGeral
                                toggleSelectAll={toggleSelectAll}
                                selectAll={selectAll}
                                itensConsulta={itensConsulta}
                            />
                        );
                        break;
                    default:
                        return null;
                }
            }
        } catch (ex) {
            return null;
        }

        const renderHeader = (showHeader = true) =>{
            return (
                <HomeHeader
                    showheader={showHeader}
                    ordenacao={ordenacao}
                    mudarPaginaResultado={mudarPaginaResultado}
                    limparConsulta={limparConsulta}
                    mudarQuantidadePerPag={mudarQuantidadePerPag}
                    guiaSelecionada={guiaSelecionada}
                    showModoExibicao={usaModoExibicao}
                />
            )
        }

        return (
            <div className="consultaContent col-md-12">
                <Row className="bkbranco pt-2 pb-2 pl-0 pr-0 rad5 b-w2 b-tema10 b-solid">
                    {usaHeader ? renderHeader() : ''}
                    <Col xs="12" className="p-0">
                        <Row
                            className={`mt-3 pt-1 pb-3 ${
                                usaHeader && 'border-top'
                            }`}
                        >
                            {content}
                        </Row>
                    </Col>
                    {usaHeader ? renderHeader(false) : ''}
                </Row>
            </div>
        );
    };

    return (
        <BaseTemplate guiaSelecionada={guiaSelecionada}>
            {getContent()}
        </BaseTemplate>
    );
}

const mapStateToProps = state => ({
    consultaRx: state.pesquisa.consulta,
    acervosFiltradosRx: state.pesquisa.acervosFiltrados,
    ultimoLogRx: state.pesquisa.log[state.pesquisa.log.length - 1],
    statusRx: state.pageConfig.status,
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
    opcoesResultadoRx: state.pesquisa.opcoesResultado,
    opcoesNovasAquisicoes: state.pesquisa.opcoesNovasAquisicoes,
    cestaRx: state.cesta.itens,
    filtrosSelecionados: state.pesquisa.filtros,
    logoById: state.pageConfig.logoById,
});

export default connect(mapStateToProps)(Home);
